import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  GET_ORDER_DETAIL,
  GET_ORDERS,
  UPDATE_ORDER,
  DELETE_ORDER,
  CONVERT_TO_ORDER,
} from "./actionTypes"

import {
  convertToOrderFail,
  convertToOrderSuccess,
  deleteOrderFail,
  deleteOrderSuccess,
  getAuthUsersFail,
  getAuthUsersSuccess,
  getOrderDetailFail,
  getOrderDetailSuccess,
  getOrdersFail,
  getOrdersSuccess,
  updateOrderFail,
  updateOrderSuccess
} from "./actions"

//Include Both Helper File with needed methods
import {
  getOrders,
  getOrderDetail,
  getOrderComents as getOrderComentsApi, 
  deleteOrdersURL,
    convertToOrder as callConvertToOrder,
    updateOrder
} from "helpers/fakebackend_helper"

function* fetchOrders(props) {
  try {
    const response = yield call(getOrders, props.payload)
    yield put(getOrdersSuccess(response))
  } catch (error) {
    yield put(getOrdersFail(error))
  }
}


function* convertToOrder({payload}) {
  try {
    const response = yield call(callConvertToOrder,  payload)
    if(response && response.status === 200) {
      yield put(convertToOrderSuccess(response))
    }
    
  } catch (error) {
    yield put(convertToOrderFail(error))
  }
}

function* updateOrdersFun({payload}) {
  try {
    const response = yield call(updateOrder, payload)
    yield put(updateOrderSuccess(response))
  } catch (error) {
    yield put(updateOrderFail(error))
  }
}


function* fetchOrderDetail({ vectorId }) {
  try {
    const response = yield call(getOrderDetail, vectorId)
    yield put(getOrderDetailSuccess(response))
  } catch (error) {
    yield put(getOrderDetailFail(error))
  }
}
function* deleteOrders(vectorId ) {
  try {
    const response = yield call(deleteOrdersURL, vectorId.payload)
    yield put(deleteOrderSuccess(response))
  } catch (error) {
    yield put(deleteOrderFail(error))
  }
}

function* vectorsSaga() {
  yield takeEvery(GET_ORDERS, fetchOrders)
  yield takeEvery(GET_ORDER_DETAIL, fetchOrderDetail)
  yield takeEvery(UPDATE_ORDER, updateOrdersFun)
  yield takeEvery(DELETE_ORDER,deleteOrders)
  yield takeEvery(CONVERT_TO_ORDER, convertToOrder)

}

export default vectorsSaga


